/**
 * File: useInvoicesQueries.ts
 * Path: apps/admin/src/shared/hooks/useInvoicesQueries.ts
 * Description: Saved invoices, and which payment each one is for, so a
 * payment shows "Invoice INV-000015" once it has one instead of offering to
 * make another.
 */
import { useQuery } from "@tanstack/react-query";
import { INVOICE_COLLECTIONS, type SavedInvoice } from "@idk/config";
import { getInvoice, listInvoices } from "../services/invoicePreviewService";

export const invoicesKey = [INVOICE_COLLECTIONS.invoices] as const;

export const useInvoices = () => useQuery({ queryKey: invoicesKey, queryFn: listInvoices });

export const useInvoice = (id: string | undefined) =>
  useQuery({
    queryKey: [...invoicesKey, id ?? ""],
    queryFn: () => getInvoice(id as string),
    enabled: Boolean(id),
  });

/** Saved invoices by the payment reference they are for. */
export const invoicesByPayment = (invoices: SavedInvoice[] | undefined): Map<string, SavedInvoice> =>
  new Map((invoices ?? []).filter((i) => i.draft.paymentReference).map((i) => [i.draft.paymentReference, i]));
